import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import StoreOverview from "./overview";
import OpeningHours from "./opening-hours";
import OrderCapacity from "./order-capacity";
import Notifications from "./notifications";

export const Settings = () => {
  return (
    <Routes>
      <Route path="overview" element={<StoreOverview />} />
      <Route path="opening-hours" element={<OpeningHours />} />
      <Route path="order-capacity" element={<OrderCapacity />} />
      <Route path="notifications" element={<Notifications />} />
      <Route path="" element={<Navigate to="overview" replace />} />
    </Routes>
  );
};

export default Settings;
